<template>
  <NavBar
      v-if="showBar"
      :logo-url="logoPath"
      :on-logo-click="handleLogoClick"
      :style="barStyles"
      hide-menu
  />
</template>

<script setup>
import NavBar from "@intec/vue-components/navigation/NavBar.vue";
import { inject, computed } from 'vue';

const themeData = inject('themeData', {});

const logoPath = computed(() => themeData?.logoPath);
const showBar = computed(() => !!themeData?.header?.bar);
const barLink = computed(() => themeData?.header?.bar?.logoLink || '');
const barStyles = computed(() => themeData?.header?.bar?.styles || '');

const handleLogoClick = () => {
  if (barLink) {
    window.open(barLink.value, '_blank');
  }
}
</script>
